"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.axiosCancelToken = exports.setTokenHeaders = exports.axiosInstance = void 0;
var axios_1 = __importDefault(require("axios"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var SESSION_NAME = "platfi-ui-app/SESSION";
var SESSION_NAME_MARKETPLACE = "platfi-ui-app/SESSION/MARKETPLACE";
var axiosCancelToken = axios_1["default"].CancelToken;
exports.axiosCancelToken = axiosCancelToken;
var logoutBackToLogin = function () {
    localStorage.clear();
    var url = "".concat(window._env_.SPA_DOMAIN, "/login");
    window.location.href = url;
};
var axiosInstance = axios_1["default"].create();
exports.axiosInstance = axiosInstance;
axiosInstance.interceptors.request.use(function (config) {
    var _a, _b;
    var token = localStorage.getItem(SESSION_NAME);
    var marketplaceToken = localStorage.getItem(SESSION_NAME_MARKETPLACE);
    if (!!config.marketplace && marketplaceToken) {
        if (!!token) {
            config.headers["Authorization"] = "Bearer ".concat((_a = JSON.parse(marketplaceToken || "{}")) === null || _a === void 0 ? void 0 : _a.accessToken);
        }
        return config;
    }
    if (!!token) {
        config.headers["Authorization"] = "Bearer ".concat((_b = JSON.parse(token || "{}")) === null || _b === void 0 ? void 0 : _b.accessToken);
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) {
    if (error.response.status === 401) {
        var token = localStorage.getItem(SESSION_NAME);
        if (!token) {
            return logoutBackToLogin();
        }
        var decoded = (0, jwt_decode_1["default"])(token);
        if (!(decoded === null || decoded === void 0 ? void 0 : decoded.exp)) {
            return logoutBackToLogin();
        }
        var d = new Date(0);
        d.setUTCSeconds(decoded === null || decoded === void 0 ? void 0 : decoded.exp);
        if (d.getTime() < new Date().getTime()) {
            logoutBackToLogin();
        }
    }
    return Promise.reject(error);
});
var setTokenHeaders = function (token) {
    if (token) {
        axiosInstance.defaults.headers["Authorization"] = token
            ? "Bearer ".concat(token)
            : undefined;
        localStorage.setItem(SESSION_NAME, JSON.stringify({ accessToken: token }));
    }
};
exports.setTokenHeaders = setTokenHeaders;
